
import React from 'react';
import {createPurchase, setupStore} from 'components/checkout/setup';
import {usePrices} from 'components/utils/usePrices';
import {Routes} from 'constants/index';
import PricingCard from 'pages/pricing/components/PricingCard';

import * as styles from './styles.module.scss';

type CardsResult = {
	cards: React.ReactNode[]
	loading: boolean
	error: boolean
}

export const useCards = (): CardsResult => {
	const {isLoading, hasError, id, memberships, oneTime} = usePrices();
	if (isLoading || hasError) {
		return {
			cards: [],
			loading: isLoading,
			error: Boolean(hasError),
		};
	}

	const MONTH = memberships.MONTH;
	const QUARTER = memberships.QUARTER;
	const productId = id;

	const cards = [
		<PricingCard
			className={styles.card} key='monthly'
			highlight='Most Savings'
			title='Monthly'
			description='Track progress like a pro: Set your fitness baseline and get insightful updates regularly.'
			prices={{
				button: 'Buy & save',
				single: {
					price: MONTH[0].price.total.toFixed(2),
					text: '1 scan / month, paid monthly',
					onClick: () => {
						setupStore(createPurchase({
							product: productId,
							interval: MONTH[0].renewInterval,
							quantity: MONTH[0].price.quantity,
							redirect: Routes.dashboard,
						}));
					},
				},
				double: {
					price: MONTH[1].price.total.toFixed(2),
					text: '2 scans / month, paid monthly',
					onClick: () => {
						setupStore(createPurchase({
							product: productId,
							interval: MONTH[1].renewInterval,
							quantity: MONTH[1].price.quantity,
							redirect: Routes.dashboard,
						}));
					},
				},
			}}
		/>,
		<PricingCard
			className={styles.card} key='quarterly'
			highlight='Most Popular'
			title='Quarterly'
			description='The perfect plan for tracking your body comp changes over longer periods of time.'
			prices={{
				button: 'Buy & save',
				single: {
					price: QUARTER[0].price.total.toFixed(2),
					text: '1 scan / quarter, paid quarterly',
					onClick: () => {
						setupStore(createPurchase({
							product: productId,
							interval: QUARTER[0].renewInterval,
							quantity: QUARTER[0].price.quantity,
							redirect: Routes.dashboard,
						}));
					},
				},
				double: {
					price: QUARTER[1].price.total.toFixed(2),
					text: '2 scans / quarter, paid quarterly',
					onClick: () => {
						setupStore(createPurchase({
							product: productId,
							interval: QUARTER[1].renewInterval,
							quantity: QUARTER[1].price.quantity,
							redirect: Routes.dashboard,
						}));
					},
				},
			}}
		/>,
		<PricingCard
			className={styles.card} key='one-time'
			title='One-time'
			description="Not yet ready to commit? Come try us out! We've made scans more affordable than ever!"
			prices={{
				button: 'Buy now',
				single: {
					price: oneTime[0].toFixed(2),
					text: 'for 1 baseline scan',
					onClick: () => {
						setupStore(createPurchase({
							product: productId,
							quantity: 1,
							redirect: Routes.dashboard,
						}));
					},
				},
				double: {
					price: oneTime[1].toFixed(2),
					text: '2 scans, baseline and follow-up',
					onClick: () => {
						setupStore(createPurchase({
							product: productId,
							quantity: 2,
							redirect: Routes.dashboard,
						}));
					},
				},
			}}
		/>,
	];

	return {
		cards,
		loading: isLoading,
		error: Boolean(hasError),
	};
};
